/* Global imports. */
import React from "react";
import {cleanStringForPath} from "@src/helpers"
import KontentFieldRichText from "@models/kontent/KontentFieldRichText"

interface Props {
  value: KontentFieldRichText
  isQuickPreview?: boolean
}

function AnchorLinksIndex({ value, isQuickPreview }: Props) {

  let anchorLinksArray:string[] = []

  const anchorLinksContent = isQuickPreview ? value.linkedItems : value.modular_content

  const filteredAnchorLinks = anchorLinksContent.forEach(x => {
    if(x.system.type === "anchor_links" && x.elements.short_title.value) {
      anchorLinksArray.push(x.elements.short_title.value)
    }
  })

  return (
    <>    
    {anchorLinksArray.length > 0 && (
    <div className="relative w-full mb-8">
          <ul className="!pl-0 !list-none">
            {anchorLinksArray.map((anchor, i) => (
              <li className="inline-block mb-2 mr-2" key={`anchorlink-${cleanStringForPath(anchor)}`}>
                <a href={`#${cleanStringForPath(anchor)}`} className="inline-block rounded-md no-underline bg-[#E5E5E5] hover:bg-[#CCCCCC] p-2 font-sans text-sm">{anchor}</a>
              </li>
            ))}
          </ul>
    </div>
    )}
    </>
  );
}

export default AnchorLinksIndex;
